import t from"styled-components";const e=t.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
`,i=t.div`
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;

	${({isDisabled:t})=>t?"\n\t\t\topacity: 0.5;\n\t\t\tcursor: not-allowed;\n\t\t":""};
`,n=t.div`
	color: ${({theme:t})=>t.text.text};
	font-family: 'PP Formula';
	font-size: 13px;
	font-weight: 500;
	line-height: 18px;
	margin-top: 2px;
`;export{i as ButtonContainer,n as Content,e as PrevNextContainer};
